<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: shenlin
 * @LastEditTime: 2021-12-01 10:55:48
-->
<template>
  <div class="app-container">
    <div class="title">{{ name }}公告</div>
    <div class="content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="通知公告标题：" prop="informTitle">
          <el-input
            class="author"
            v-model="ruleForm.informTitle"
            maxlength="50"
            show-word-limit
            placeholder="请输入通知公告标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="作者：" prop="creator">
          <el-input class="author" placeholder="请输入作者名称" v-model="ruleForm.creator"></el-input>
        </el-form-item>
        <el-form-item label="所属区域：" prop="areaCode">
          <el-select
            v-model="ruleForm.areaCode"
            placeholder="请选择区域"
            @change="countyCode"
            clearable
          >
            <el-option
              v-for="item in areaList"
              :key="item.code"
              :label="item.county"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="author" label="内容简介：">
          <!-- <el-input type="textarea" v-model="ruleForm.content"></el-input> -->
          <div id="editor" class="author"></div>
        </el-form-item>
        <el-form-item label="附件：" class="author">
          <el-upload
            ref="uploader"
            :action="uploadFileByContentType"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove1"
            multiple
            accept=".rar, .zip ,.doc ,.docx ,.pdf, .jpg"
            :headers="uploadHeader"
            :limit="3"
            :file-list="fileList1"
            :on-success="docSuccess1"
            :on-exceed="handleExceed"
          >
            <el-button icon="el-icon-upload2">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              支持扩展名：.rar .zip .doc .docx .pdf
              .jpg,文件大小不超过100M，最多上传3个
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm()">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getArea } from '@api/activityCenter/activityCenter'

import { wEditorDefaultConfig } from '@constant'
import { uploadFileByContentType } from '@api/activityCenter/activityCenter'
import {
  addInformNotice,
  updateInformNotice,
  getDetailById
} from '@api/announcement/index'
import { isHttp, getToken } from '@utils'
export default {
  name: 'Live',
  data() {
    return {
      uploadFileByContentType,
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      name: '新增',
      dialogVisible: false,
      hideUpload: false,
      areaList: [],
      isCounty: this.$store.state.user.userInfo.roleText,

      ruleForm: {
        informTitle: '', // 直播名称
        creator: '', // 主办单位
        content: '', // 内容简介
        ossUrl: '', // 附件ulr
        fileName: '', // 附件名称
        areaCode: '',
        county: ''
      },
      fileList: [],
      fileList1: [],
      rules: {
        informTitle: [
          { required: true, message: '请输入通知公告标题', trigger: 'blur' }
        ],
        creator: [{ required: true, message: '请输入作者', trigger: 'blur' }],
        areaCode: [
          { required: true, message: '请选择所属区域', trigger: 'blur' }
        ],
        liveUrl: isHttp()
      },
      typeList: [], // 所有类别数据
      disabled: true
    }
  },
  watch: {
    condition(val) {
      if (this.aRoute(val)) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
  },
  computed: {
    condition({ ruleForm }) {
      return {
        informTitle: ruleForm.informTitle,
        creator: ruleForm.creator
      }
    }
  },
  created() {},
  mounted() {
    this.getArea()

    if (this.$route.query.id) {
      this.getActivityData()
      this.name = '编辑'
    }
    this.wangEditor()
  },
  methods: {
    countyCode(val) {
      this.areaList.find(f => {
        if (f.code === val) {
          this.ruleForm.county = f.county
        }
      })
    },
    /** 获取丽水市以及各个区县 */
    getArea() {
      getArea({}).then(res => {
        if (res.data.code == '0000') {
          this.areaList = res.data.data || []
          this.ruleForm.areaCode =
            this.areaList.length > 0 ? this.areaList[0].code : ''
          // if (this.isCounty === '区域管理员') {
          this.ruleForm.county =
            this.areaList.length > 0 ? this.areaList[0].county : ''
          // }
        }
      })
    },
    /** 创建富文本编辑器 */
    wangEditor() {
      let E = window.wangEditor
      this.editor = new E('#editor')
      this.editor.customConfig = {
        ...this.editor.customConfig,
        ...wEditorDefaultConfig
      }
      // console.log(this.editor.customConfig)
      // 配置菜单栏，设置不需要的菜单
      // this.editor.config.excludeMenus = [
      //   'video'
      // ]
      // 富文本编辑器内容校验
      let that = this
      this.editor.customConfig.onblur = function(html) {
        // 失去焦点时触发校验
        if (that.editor.txt.html() == '<p><br></p>') {
          that.$refs.ruleForm.validateField('content')
        } else {
          that.$refs.ruleForm.clearValidate('content')
        }
      }
      this.editor.create()
    },
    getTime() {},
    changeIsLive(val) {
      if (!val) {
        if (!this.$route.query.id) {
          this.ruleForm.liveUrl = ''
          this.ruleForm.liveType = ''
        }
      }
    },
    aRoute(object) {
      // 判断对象内容是否为空
      let isEmpty = Object.keys(object).every(x => {
        // console.log(object[x])
        return object[x] !== ''
      })
      return isEmpty
    },
    /** 获取企业详情 */
    getActivityData() {
      let params = { id: this.$route.query.id }
      getDetailById({ params }).then(res => {
        if (res.data.code == '0000') {
          this.ruleForm = { ...res.data.data }

          this.editor.txt.html(this.ruleForm.content)
          if (this.ruleForm.fileList && this.ruleForm.fileList.length > 0) {
            this.fileList1 = this.ruleForm.fileList.map(value => {
              return { name: value.fileName, ossUrl: value.ossUrl }
            })
          }

          this.hideUpload = this.fileList.length >= 1
        }
      })
    },
    /**
     * @name:视频新增或者编辑
     * @test: test font
     * @msg:
     * @param {*} formName
     * @return {*}
     */
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = { ...this.ruleForm }
          let name = []
          let url = []
          data.content = this.editor.txt.html()
          this.fileList1.map(value => {
            if (value.response) {
              name.push(value.response.data.fileName)
              url.push(value.response.data.ossUrl)
            } else {
              name.push(value.name)
              url.push(value.ossUrl)
            }
          })
          data.fileName = name.join(',')
          data.ossUrl = url.join(',')
          // debugger
          if (this.$route.query.id) {
            updateInformNotice(data).then(res => {
              if (res.data.code == '0000') {
                this.$message.success(res.data.msg)
                this.$router.push({ name: 'cementList' })
              } else {
                this.$message.error(res.data.msg)
              }
            })
          } else {
            addInformNotice(data).then(res => {
              if (res.data.code == '0000') {
                this.$message.success(res.data.msg)
                this.$router.push({ name: 'cementList' })
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm() {
      this.$router.push({ name: 'cementList' })
    },
    handleChange(file, fileList) {
      this.hideUpload = fileList.length >= 1
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList)
      this.hideUpload = fileList.length >= 1
      this.ruleForm.coverUrl = ''
    },
    handleRemove1(file, fileList) {
      this.fileList1 = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    docSuccess1(response, file, fileList) {
      if (response.code == '0000') {
        this.fileList1 = fileList
        // this.ruleForm.ossUrl = response.data.ossUrl
        // this.ruleForm.fileName = response.data.fileName
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
      }
      return isLt2M
    },
    handleExceed() {
      this.$message.warning('当前限制选择 3 个文件，已上传了3个文件')
    }
  }
}
</script>
<style>
.author {
  width: 689px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
.app-container {
  overflow-y: auto;
  & > .content {
    margin-top: 30px;
    width: 60%;
  }
}
</style>
